import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import * as R from 'Router/routes';
import LockIcon from 'assets/icons/lock.svg?react';
import CardWithIcon from 'components/CardWithIcon/CardWithIcon';
import { TwButton } from 'components/TwButton/TwButton';
import usePSD2Guide from './usePSD2Guide';

const guideItems = [
  'default.step_1',
  'default.step_2',
  'default.step_3',
] as const;

function OrderedList() {
  const { t } = useTranslation('psd2_guide');
  return (
    <div className="p-5 bg-background-accent rounded-md w-full">
      <ol className="flex flex-col gap-4" data-test="psd2Guide-list">
        {guideItems.map((item, index) => (
          <li
            key={t(item)}
            className="flex gap-4"
            data-test={`psd2Guide-element-${index}`}
          >
            <div
              className="flex justify-center items-center border-2 border-primary rounded-full h-7 w-7 flex-shrink-0 bg-background text-primary font-semibold"
              data-test={`psd2Guide-element-${index}-left`}
            >
              {index + 1}
            </div>
            <div data-test={`psd2Guide-element-${index}-right`}>{t(item)}</div>
          </li>
        ))}
      </ol>
    </div>
  );
}

function PSD2Guide() {
  const { t } = useTranslation('psd2_guide');
  const { bankName, initPSD2Session, isManual, pending } = usePSD2Guide();

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <CardWithIcon
        heading={
          <span>
            {t('title')} <span className="text-primary">{bankName}</span>
          </span>
        }
        icon={<LockIcon />}
        className="border-none lg:border-1 rounded-none lg:rounded-lg"
      >
        <OrderedList />
        <div className="mx-auto lg:mx-0 w-full flex justify-center lg:justify-start">
          <TwButton
            onClick={initPSD2Session}
            data-test="continue"
            disabled={pending}
            pending={pending}
          >
            {t('continue')}
          </TwButton>
        </div>
      </CardWithIcon>

      <Link
        type="button"
        className="flex text-primary mx-auto lg:mx-0 mb-10 hover:underline text-left w-fit"
        data-test="back"
        to={isManual ? R.MANUAL_PSD2_BANKS : R.PSD2_BANKS}
      >
        {t('back')}
      </Link>
    </>
  );
}

export default PSD2Guide;
